<template>
  <!-- 图片放大 -->
  <div class="big-picture" v-if="bigShowLook">
    <div class="carousel">
      <div class="back">
        <van-icon name="arrow-left" @click="bigShowLook = false"></van-icon>
        <p>{{ numIndexLook + 1 }}/{{ galleryVosList.length }}</p>
        <span></span>
      </div>
      <div class="swiper">
        <van-swipe :loop="false" :show-indicators="false" :initial-swipe="numIndexLook" @change="Slide">
          <van-swipe-item v-for="(item, index) in galleryVosList" :key="index" @click="bigShowLook = false">
            <div>
              <van-image v-if="item" :src="item" width="100vw" fit="cover"></van-image>
              <van-image v-else :src="''" height="50vh" width="100vw" fit="cover"></van-image>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customvan-display-image",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    propF: {},
  },
  data() {
    return {
      // 图片放大
      galleryVosList: [],
      bigShow: false, // 图片变大
      numIndex: 0, // 显示第几个
      bigShowLook: false, // 图片变大
      numIndexLook: 0, // 显示第几个
    };
  },
  created() { },
  methods: {
    showBigPictureLook(images, index) {
      event.stopPropagation();
      console.log(images, '123456')
      this.galleryVosList = images;
      this.numIndexLook = index;
      this.bigShowLook = true;
    },
    Slide(index) {
      this.numIndex = index;
      this.numIndexLook = index;
    },
  },
  computed: {},
  watch: {
    //eslint-disable-next-line
    bigShowLook: function (newVal, oldVal) {
      this.$emit("isShowWatch", newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.big-picture {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1200;
  background: #000;
  .carousel {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .swiper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      /deep/ .van-swipe {
        width: 100%;
      }
      /deep/ .van-swipe__track {
        height: 600px;
      }
      /deep/ .van-image {
        max-height: 600px;
      }
      /deep/ .van-swipe-item {
        display: flex;
        align-items: center;
      }
      .images-box {
        width: 100%;
      }
    }
    .back {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1300;
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      /deep/ .van-icon {
        font-size: 20px;
        font-weight: 600;
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFangSC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
      }
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
